<div class="construction">
    <h1 style="margin-top: 100px;">Website in Maintenance! We will be live again shortly with the best Student Insurance Plans!</h1>
    <div class="centralize">
        <img src="./../../../assets/img/gif/hogwarts-maintenance.gif" width="500" height="500" alt="construction">
    </div>
</div>